import { ChangeDetectorRef, Component, ElementRef, HostListener, inject, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LeadService } from '../../../service/lead.service';
import { ClevertapService } from '../../../service/clevertap.service';
import { ToastService } from '../../../service/toast.service';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AsahiOtpModalComponent } from '../asahi-otp-modal/asahi-otp-modal.component';
import { CalendarPickerComponent } from '../calendar-picker/calendar-picker.component';

@Component({
  selector: 'app-mobile-premium-cal',
  imports: [ReactiveFormsModule, TranslatePipe, AsahiOtpModalComponent, FormsModule, CommonModule, CalendarPickerComponent],
  templateUrl: './mobile-premium-cal.component.html',
  styleUrl: './mobile-premium-cal.component.scss'
})
export class MobilePremiumCalComponent {
  form!: FormGroup;
  fb = inject(FormBuilder);
  userMobileNo: any;
  clevertapService = inject(ClevertapService);
  leadService = inject(LeadService)
  router = inject(Router)
  _actRoute = inject(ActivatedRoute)
  toastService = inject(ToastService);
  /** Selected occupation */
  selectedOcuupation: string | null = null;
  selectedPhoneOption: string | null = null;
  selectedAction: string | null = null;
  activeDropdown: string | null = null;
  insuranceFor: string[] = [];
  showInsuranceForOthers = false;
  @ViewChild('phoneInput') phoneInput!: ElementRef;
  /** Current language */
  private currentLang!: string;
  /** Current query */
  private currentQueryParams: any = {};
  /** List of ocuupation */
  occupation = ['Office worker', 'Engineer', 'Teacher', 'Driver', 'Freelancer', 'Others'];
  userDetails: any;
  parallaxOffset = 0;
  selectedCountryCode: string = '+84';
  phoneVerified: boolean = false;
  verifiedPhoneNumber: string = ''; // Store the verified phone number
  showOtpModal = false;
  otpPhoneMasked = '';
  otpCountryCode = '84';
  otpMobileNo = '';
  otpLoading = false;
  otpErrorMsg = '';
  source!: boolean;
  /** Selected age */
  selectedAge: string | null = null;
  /** List of age */
  age = ['16-19', '20-24', '25-29', '30-34', '35-39', '40-44', '45-49', '50-54', '55-59', '60-64', '65'];
  /** Controls visibility of age dropdown */
  showAgeDropdown = false;
  isLoading: boolean = false;

  // ---------- Constructor & Form Setup ----------
  constructor(private elementRef: ElementRef, private route: ActivatedRoute, private cdr: ChangeDetectorRef) {
    // Initialize reactive form with validators
    this.form = this.fb.group({
      name: ['', Validators.required],
      phone: '',
      type: "income_protection",
      mobileNo: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      yearOfBirth: ['', Validators.required],
      gender: ['', Validators.required],
      averageMonthlyIncome: ['', Validators.required],
      occupation: ['', Validators.required],
      beneficiaryAgeRange: '',
      insuranceFor: [[], Validators.required],
      consent: [false, Validators.requiredTrue],
    });
  }

  // ngOnInit is a lifecycle hook in Angular
  ngOnInit() {
    this.clevertapService.trackEvent('visited_lead_form', {
      product_type: this.form.get('type')?.value
    });
    this._actRoute.url.subscribe(urlSegments => {
      this.source = urlSegments.some(segment => segment.path === 'mobile');
    });

    this.currentLang = this.router.url.split('/')[1]; // 0: "income-protection-insurance", 1: "vi"
    console.log('Lang from ActivatedRoute:', this.currentLang);
    this._actRoute.queryParams.subscribe((queryParams) => {
      this.currentQueryParams = { ...queryParams };
    });
    this._actRoute.queryParams.subscribe(queryParams => {
      const userId = queryParams['userId'];
      if (userId && this.source) {
        this.fetchUserDetails(userId);
      } else {
        this.clevertapService.clearStorage();
        // If no userId, set validators for new phone as it will be required
        this.form.get('mobileNo')?.setValidators([Validators.required, Validators.pattern(/^\d{10}$/)]);
        this.form.get('mobileNo')?.updateValueAndValidity();
      }
    });

  }
  /** To fetch user details */
  private fetchUserDetails(userId: string) {
    this.leadService.getUserDetails(userId).subscribe({
      next: (response: any) => {
        console.log(response.data);
        if (response.success) {
          this.userDetails = response.data;
          this.clevertapService.saveUserDetails(this.userDetails);
          this.form.get('name')?.setValue(this.userDetails.name);
          if (this.userDetails.mobileNo) {
            this.form.get('phone')?.setValue('yes');
            this.form.get('mobileNo')?.setValue(this.userDetails.mobileNo);
            if (!this.form.get('mobileNo')?.value.startsWith('0')) {
              this.userMobileNo = '0' + this.form.get('mobileNo')?.value;
              this.form.get('mobileNo')?.patchValue(this.userMobileNo)
            }
          } else {
            // If no existing phone number, set validators for new phone
            this.form.get('mobileNo')?.setValidators([Validators.required, Validators.pattern(/^\d{10}$/)]);
            this.form.get('mobileNo')?.updateValueAndValidity();
          }

          // Set CleverTap user profile when user details are fetched
          const user = this.userDetails;
          const name = user.name || '';
          const firstName = name.split(' ')[0] || '';
          const lastName = name.split(' ').slice(1).join(' ') || '';
          const email = user.email || '';
          const phoneNumber = user.mobileNo || '';
          const countryCode = user.countryCode || this.selectedCountryCode.replace('+', '') || '84';
          const customerId = `${countryCode}-${phoneNumber}`;

          if (email || phoneNumber) {
            this.clevertapService.setUserProfile(email, firstName, lastName, phoneNumber, name, this.userDetails.uuid);
          }
        }

      },
      error: (error) => {
        console.error('Error fetching user details:', error);
        // If error fetching user details, set validators for new phone
        this.form.get('mobileNo')?.setValidators([Validators.required, Validators.pattern(/^\d{10}$/)]);
        this.form.get('mobileNo')?.updateValueAndValidity();
      }
    });
  }
  onCheck() {
    const basePath = [this.router.url.split('/')[2]];
    this.router.navigate([this.currentLang, ...basePath, 'mobile-premium-form'], {
      queryParams: this.currentQueryParams
    }).then(() => {
      window.scrollTo(0, 0);
    });
  }
  // ---------- Form Submission ----------
  /** Submits the lead form after validation and triggers phone verification */
  onSubmit() {
    const mobileNo = this.form.get('phone')?.value === 'yes'
      ? this.userDetails?.mobileNo
      : this.form.get('mobileNo')?.value;

    if (this.form.invalid) {
      console.log('Form is invalid');
      this.form.markAllAsTouched();
      return;
    }

    if (!this.form.get('consent')?.value) {
      console.log('Consent is required');
      return;
    }

    if (this.form.get('insuranceFor')?.value.length === 1 && this.form.get('insuranceFor')?.value?.[0] === 'SELF') {
      this.form.get('beneficiaryAgeRange')?.reset();
    }

    const payload = {
      name: this.form?.get('name')?.value,
      mobileNo: mobileNo,
      yearOfBirth: this.form?.get('yearOfBirth')?.value,
      type: "INCOME_PROTECTION_INSURANCE",
      gender: this.form.get('gender')?.value,
      averageMonthlyIncome: this.form.get('averageMonthlyIncome')?.value,
      occupation: this.form.get('occupation')?.value,
      insuranceFor: this.form.get('insuranceFor')?.value,
      beneficiaryAgeRange: this.form.get('beneficiaryAgeRange')?.value || ""
    };

    console.log(payload);

    this.isLoading = true; // ✅ start loader

    this.leadService.submitLead(payload).subscribe({
      next: (response) => {
        console.log(response);
        this.isLoading = false; // ✅ stop loader
        this.onVerifyPhone();
        this.clevertapService.trackEvent('submit_lead_form', { product_type: payload });
      },
      error: (error) => {
        console.error('Error submitting lead:', error);
        this.isLoading = false; // ✅ stop loader
        this.toastService.error('Error', 'Failed to submit lead. Please try again.');
      }
    }).add(() => {
      // Finally block - always executed
      this.isLoading = false;
      this.otpLoading = false;
    });
  }


  // ---------- Phone Verification & OTP ----------
  /** Initiates OTP verification for the entered phone number */
  onVerifyPhone() {
    const countryCode = this.selectedCountryCode.replace('+', '') || '84';
    const mobileNo = this.form.get('phone')?.value === 'yes'
      ? this.userDetails?.mobileNo
      : this.form.get('mobileNo')?.value;
    if (!mobileNo || mobileNo.length < 8) {
      this.toastService.error('Validation Error', 'Please enter a valid phone number before requesting OTP.');
      return;
    }

    this.otpCountryCode = countryCode;
    this.otpMobileNo = mobileNo;
    this.otpLoading = true;
    this.otpErrorMsg = '';
    this.showOtpModal = true;

    const payload = { countryCode, mobileNo };
    console.log(payload);

    this.leadService.sendOtp(payload).subscribe({
      next: (response) => {
        this.otpPhoneMasked = mobileNo;
        this.showOtpModal = true;
        this.otpLoading = false;
      },
      error: (err) => {
        this.otpLoading = false;
        this.otpErrorMsg = 'Invalid OTP. Please try again.';
        this.toastService.showApiError(err, this.otpErrorMsg);
        console.error('OTP verification error:', err);
        // Restore scroll even on error (modal might close)
        document.body.style.overflow = 'auto';
      },
    }).add(() => {
      // Finally block - always executed
      this.otpLoading = false;
      // Ensure scroll is always restored
      document.body.style.overflow = 'auto';
    });
  }

  /** Allows user to edit the phone number after OTP modal is open */
  onOtpEdit() {
    this.showOtpModal = false;
    document.body.style.overflow = 'auto';
    this.form.get('mobileNo')?.enable();
    setTimeout(() => {
      this.phoneInput.nativeElement.focus();
    }, 0);
    this.otpLoading = false;
    this.otpErrorMsg = '';
    this.phoneVerified = false;
    this.verifiedPhoneNumber = '';
  }

  /** Closes OTP modal and resets loading/error states */
  onOtpClosed() {
    this.showOtpModal = false;
    this.otpLoading = false;
    this.otpErrorMsg = '';
    document.body.style.overflow = 'auto';
  }

  /** Dispatches a global event to reset OTP modal */
  resetOtpModal() {
    const resetEvent = new CustomEvent('resetOtpModal');
    window.dispatchEvent(resetEvent);
  }

  /** Handles OTP verification success/failure */
  onOtpVerified(otp: any) {
    this.otpLoading = true;
    this.otpErrorMsg = '';
    const phone = this.otpMobileNo;
    const formatted = phone.replace(/^0/, '');
    const payload = {
      countryCode: this.otpCountryCode,
      mobileNo: formatted,
      otp: otp
    };
    console.log(payload);

    this.leadService.verifyOtp(payload).subscribe({
      next: (response) => {
        this.phoneVerified = true;
        this.verifiedPhoneNumber = this.otpMobileNo;
        this.showOtpModal = false;
        document.body.style.overflow = 'auto';
        this.otpLoading = false;
        this.otpErrorMsg = '';
        this.resetOtpModal();
        this.form.reset();
        this.form.get('insuranceFor')?.setValue([]);
        this.form.get('yearOfBirth')?.setValue('');
        const currentLang = this.router.url.split('/')[1]; // 0: "income-protection-insurance", 1: "vi"
        console.log('Lang from ActivatedRoute:', currentLang);
        const source = this.route.snapshot.queryParamMap.get('source') || '';
        const userId = this.route.snapshot.queryParamMap.get('userId') || '';

        this.router.navigate(
          [`${currentLang}/income-protection-insurance`, 'mobile-success-page'],
          {
            queryParams: { source, userId }
          }
        ).then(() => {
          window.scrollTo(0, 0);
        });
        this.toastService.success('Success', 'Phone number verified successfully!');
      },
      error: (err) => {
        this.otpLoading = false;
        this.otpErrorMsg = err.error?.message || 'OTP verification failed. Please try again.';
        console.error('OTP verification error:', err);
      },
    }).add(() => {
      // Finally block - always executed
      this.otpLoading = false;
    });
  }

  /** Sends Zalo OTP */
  onOtpZaloVerify() {
    this.otpLoading = true;
    this.otpErrorMsg = '';
    const phone = this.otpMobileNo;
    const formatted = phone.replace(/^0/, '');
    const payload = { countryCode: this.otpCountryCode, mobileNo: formatted };
    console.log(payload);

    this.leadService.sendZaloOtp(payload).subscribe({
      next: (response: any) => {
        this.otpLoading = false;
        this.toastService.showApiSuccess(response, 'Zalo OTP sent successfully!');
      },
      error: (err: any) => {
        this.otpLoading = false;
        this.otpErrorMsg = 'Failed to send Zalo OTP. Please try again.';
        this.toastService.showApiError(err, this.otpErrorMsg);
        console.error('Zalo OTP send error:', err);
      }
    });
  }

  /** Placeholder for Call OTP verification (not implemented yet) */
  onOtpCallVerify() {
    this.otpLoading = false;
    this.toastService.info('Info', 'Call verification is not implemented yet.');
  }
  /** Updates the number */
  formatPhone(event: any) {
    let input = event.target.value.replace(/\D/g, '').substring(0, 10);
    const area = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);

    if (input.length > 6) {
      event.target.value = `(${area}) ${middle}-${last}`;
    } else if (input.length > 3) {
      event.target.value = `(${area}) ${middle}`;
    } else if (input.length > 0) {
      event.target.value = `(${area}`;
    }
    this.form.get('mobileNo')?.setValue(input);

    if (!input.startsWith('0')) {
      this.form.get('mobileNo')?.setErrors({ invalidPhone: true });
    }
    this.cdr.detectChanges();

  }

  /** Updates the phone number */
  getMaskedPhone(phone: string): string {
    if (!phone) return '';
    return phone.slice(0, 3) + 'XXXXXXX';
  }

  /** Updates the dropdown */
  toggleDropdown(name: string) {
    this.activeDropdown = this.activeDropdown === name ? null : name;
  }

  /** Updates the dropdown */
  closeDropdown() {
    this.activeDropdown = null;
  }

  /** Selects a occupation and updates the form */
  selectOcuupation(occupation: string) {
    this.selectedOcuupation = occupation;
    this.form.get('occupation')?.setValue(occupation);
  }
  /** Selects a showInsuranceForOthers and updates the form */
  toggleSelection(option: string) {
    if (this.insuranceFor.includes(option)) {
      this.insuranceFor = this.insuranceFor.filter(item => item !== option);
    } else {
      this.insuranceFor.push(option);
    }
    this.form.get('insuranceFor')?.patchValue(this.insuranceFor);
    // show conditional input if FAMILY, FRIENDS, or OTHERS is selected
    this.showInsuranceForOthers = this.insuranceFor.some(opt =>
      ['FAMILY', 'FRIENDS', 'OTHERS'].includes(opt)
    );
    // reset age if none of FAMILY, FRIENDS, OTHERS are selected
    if (!this.showInsuranceForOthers) {
      this.selectedAge = null;
      this.form.get('beneficiaryAgeRange')?.reset();
    }
  }
  /** Selects a age and updates the form */
  selectAge(age: string) {
    this.selectedAge = age;
    this.form.get('beneficiaryAgeRange')?.setValue(age);
    this.showAgeDropdown = false;
    if (this.showAgeDropdown) this.showAgeDropdown = false;

  }
  /** Updates the scroll */
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.parallaxOffset = window.scrollY * 0.4;
  }
  // Listen for clicks on the document to close dropdowns if click is outside
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    // ✅ allow clicks inside dropdown-container OR inside calendar component
    if (target.closest('.dropdown-container')) {
      return;
    }
    this.closeDropdown();
  }
  // ---------- Date Picker ----------
  /** Sets insurance expiry date in the form */
  onDateSelected(selectedDate: string) {
    const selectedYear = Number(selectedDate);
    const currentYear = new Date().getFullYear();
    const control = this.form.get('yearOfBirth');

    if (selectedYear > currentYear) {
      control?.setErrors({ invalidYear: true });
      control?.markAsTouched();
    } else {
      control?.setValue(selectedYear);
      control?.markAsTouched();
      control?.setErrors(null); // clear error if valid
    }

  }

  private getTrafficSource(): string {
    // Check if we're in a mobile app webview
    const userAgent = navigator.userAgent || '';

    // Check for iOS app
    if (window.webkit?.messageHandlers?.closeHandler) {
      return 'ios_app';
    }

    // Check for Android app
    if (window.AndroidInterface?.closeWebView) {
      return 'android_app';
    }

    // Check referrer for web traffic
    const referrer = document.referrer;
    if (referrer) {
      if (referrer.includes('google')) {
        return 'google';
      } else if (referrer.includes('facebook')) {
        return 'facebook';
      } else if (referrer.includes('instagram')) {
        return 'instagram';
      } else if (referrer.includes('twitter') || referrer.includes('t.co')) {
        return 'twitter';
      } else if (referrer.includes('linkedin')) {
        return 'linkedin';
      } else if (referrer.includes('youtube')) {
        return 'youtube';
      } else {
        return 'web_referral';
      }
    }

    // Check URL parameters for UTM source
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    if (utmSource) {
      return utmSource;
    }

    // Default to direct traffic
    return 'direct';
  }
}
